import { CASE_SEARCH_PARAMS_SCHEMA } from '@repo/ccc-case-app-lib/src/constants/caseSearchParamsSchema.ts'
import { HomePage } from '@repo/ccc-case-app-lib/src/pages/HomePage.tsx'
import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/_authenticated/')({
  validateSearch: CASE_SEARCH_PARAMS_SCHEMA,
  component: CaseMainPageContainer,
})

function CaseMainPageContainer() {
  return <HomePage />
}
